import React, { FunctionComponent } from 'react';
import Text, {
    TextSize,
    TextBasicProps,
    TextCommonProps,
    TextExtendedProps,
} from 'components/typography/text';

type P2Props = TextBasicProps & TextCommonProps & TextExtendedProps;

const P2: FunctionComponent<P2Props> = (props) => {
    const {
        children,
        align,
        color,
        weight,
        isInline,
        hasEllipsis,
        hasBreakWords,
        isDangerous,
        tag,
    } = props;

    return (
        <Text
            size={TextSize.P2}
            align={align}
            color={color}
            weight={weight}
            isInline={isInline}
            hasEllipsis={hasEllipsis}
            hasBreakWords={hasBreakWords}
            isDangerous={isDangerous}
            tag={tag}
        >
            {children}
        </Text>
    );
};

export default P2;
